import Figure from "./Figure"
import Video from "./Video"
import LargeLink from "../largeLink"
import File from "./File"
import Link from "./Link"
import Grid from "../Grid"
import ImageGallery from "../ImageGallery"
import ListView from "../ListView"

const serializers = {
  types: {
    figure: Figure,
    largeLink: LargeLink,
    video: Video,
    fileUpload: File,
    grid: Grid,
    imageGallery: ImageGallery,
    listView: ListView,
    undefined: () => null,
  },
  marks: {
    link: Link,
  },
}

export default serializers
